import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getActiveBookId, getActiveSpreadId } from 'redux/selectors/app';
import { canEdit } from 'redux/selectors/orders';

import { Pagination, Spread, SpreadExtraButtons } from 'components';

import styles from './styles.scss';

@connect(state => ({
  appWidth: state.getIn(['app', 'dimensions', 'width']),
  appHeight: state.getIn(['app', 'dimensions', 'height']),
  currentSpread: getActiveSpreadId(state),
  bookId: getActiveBookId(state),
  canEdit: canEdit(state),
}))
export default class Book extends React.PureComponent {
  static childContextTypes = {
    canEdit: PropTypes.bool.isRequired,
  };

  getChildContext() {
    return {
      canEdit: this.props.canEdit,
    };
  }

  render() {
    const { currentSpread, canEdit, bookId } = this.props;

    return (
      <div className={styles.book}>
        <Spread id={currentSpread} />
        <Pagination key={`book-${bookId}`} />
        <Pagination arrowsOnly={true} />
        {canEdit ? <SpreadExtraButtons id={currentSpread} /> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/book/index.js